export default "__VITE_PUBLIC_ASSET__0e0f3c5e__"